import * as React from "react";
import {VeBoxModal} from "../../../components/modal/VeBoxModal";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";

declare var AppTranslations: AppTranslations;

type DeleteWarningModalProps = {
    close():void
    confirm():void
}


export function DeleteWarningModal({close, confirm}: DeleteWarningModalProps) {
    return (
        <VeBoxModal.Backdrop>
            <VeBoxModal style={{width: 400}}>
                <VeBoxModal.Header
                    title={AppTranslations.errorMessages.warningTitle}
                    onClose={close}
                />
                <VeBoxModal.Section style={{padding: 20}}>
                    <p className={"description"}>
                        {AppTranslations.entityDeleteProcess.warningDescription}<br/>
                        {AppTranslations.entityDeleteProcess.areYouSure}
                    </p>
                </VeBoxModal.Section>
                <VeBoxModal.StandardActions
                    onCancel={close}
                    onSubmit={confirm}
                    useSubmitLoadingButton={true}
                    submitText={AppTranslations.genericWords.confirm}
                    isSubmitLoading={false}
                />
            </VeBoxModal>
        </VeBoxModal.Backdrop>
    );
}